export enum JobStatusEnum {
  Pending = "pending",
  Executing = "executing",
  Finished = "finished",
  Failed = "failed",
}

export enum JobTypeEnum {
  GenStructPred = "pro_struct_pred", // Protein Structure Prediction
  AbStructPred = "ab_struct_pred", // Antibody Structure Prediction
  DevPred = "dev_pred", // Characterization Developability Prediction
  AbAgDocking = "ab_ag_docking", // Antibody-Antigen Docking
  AbNumbering = "ab_numbering",
  HumanPred = "humanness_pred",
  AffinityPred = "ab_aff_pred",
  Humanization = "humanization",
  AffinityOptim = "aff_optim",
  DevOptim = "dev_optim",
  DnAbDesign = "dn_ab_design",
  AbLightChainRetrieval = "ab_lightchain_retrieval",
  ProteinMpnn = "pro_mpnn",
  OptimizationAntibody = "optimization_antibody",
  ProteinStructureAlign = "protein_structure_align",
  CdrH3Design = "cdr_h3_design",
}

export enum SourceEnum {
  Upload = "upload",
  Output = "output",
  Pdb = "PDB",
  Afdb = "AF_DB",
}

export enum QueueIdentityEnum {
  LiteDock = "lite_dock",
}
